import {gql} from '@apollo/client';

export const MOLECULE_PROPERTY_PREDICTION_JOBS_QUERY = gql`
  query MoleculePropertyPredictionJobsQuery($moleculeId: StrictString!)
  @skipAudit
  @engComponent(name: MODEL_HUB) {
    moleculePropertyPredictionJobs(moleculeId: $moleculeId) {
      id
      statusCode
      createdAt
      modelName
      properties
    }
  }
`;
